import React from "react";
import img from "../../assets/newImages/pagina-iso.png";
import iso9001 from "../../assets/ISO 9001.png";
import iso14001 from "../../assets/ISO 14001.png";
import iso45001 from "../../assets/ISO 45001.png";
import "../pages.css";
import "./certificadoIso.css";

import dociso9001 from "../../assets/docs/iso9001qms.pdf";
import dociso14001 from "../../assets/docs/iso14001qms.pdf";
import dociso45001 from "../../assets/docs/iso45001qms.pdf";
import { useNavigate } from "react-router-dom";

export default function CertificadoConformidadeIso() {
  const navigate = useNavigate();
  const abrirPDF = (route) => {
    navigate(`/om/pdf?file=${encodeURIComponent(route)}`);
  };
  return (
    <article className="art-s mb-5 p-text" id="certificado-conformidade-iso">
      <section className="row m-0 sectionInit">
        <div className="c-init">
          <div className="c-init__text col-6  d-flex flex-column sect mt-5">
            <p className="fw-bolder text-decoration-underline">
              Certificado de Conformidade ISO
            </p>
            <p>
              A <b>OM DISTRIBUIDORA DE TÍTULOS E VALORES MOBILIARIOS LTDA</b>,
              implementou o Sistema de Gestão Integrado (SGI)
            </p>
            <p>
              A implementação do SGI é uma maneira de a OM afirmar, perante a
              clientes, órgãos fiscalizadores e comunidade, que não se preocupa
              somente com os lucros. Está atenta e adota procedimentos que
              preservam o meio ambiente e o bem-estar das pessoas. Em 2021, a OM
              foi a primeira Instituição Financeira da America Latina a possuir
              as certificações ISO 9001, ISO 14001 e ISO 45001.
            </p>
            <p>
              O SGI consiste em três certificações do International Organization
              for Standardization (ISO): Gestão da Qualidade (ISO 9001), Gestão
              Ambiental (ISO 14001) e Gestão da Segurança e Saúde Ocupacional
              (ISO 45001), representam uma forma de assegurar que empresas
              públicas ou privadas estejam aptas para fornecer um produto,
              serviço ou sistema conforme as exigências das agências reguladoras
              e dos clientes.
            </p>
            <p>
              Entenda mais sobre as três certificações da ISO que foram
              implantadas com o objetivo de melhorar a qualidade de produtos e
              serviços da OM:
            </p>
          </div>
          <div className="col-6 c-init__image">
            <img src={img} className="image" alt="grupo-om"></img>
          </div>
        </div>
      </section>

      <section className="c-textos-iso">
        <div>
          <img src={iso9001} alt="iso 9001"></img>
          <h3 className="fw-bold mb-3 text-center">
            ISO 9001 – Sistema de Gestão da Qualidade
          </h3>
          <p>
            É uma norma que certifica os Sistemas de Gestão da Qualidade. É um
            conjunto de ações preventivas, para garantir e padronizar um serviço
            ou um produto, tem como objetivo, trazer confiança ao cliente de que
            os produtos e serviços da empresa serão criados de modo consistente,
            a fim de que adquira uma qualidade, de acordo com aquilo que foi
            definido pela empresa.
          </p>
          <button
            className="button-pdf text-center"
            onClick={() => abrirPDF(dociso9001)}
          >
            Clique aqui para visualizar o certificado.
          </button>
        </div>

        <div>
          <img src={iso14001} alt="iso 14001"></img>
          <h3 className="fw-bold mb-3 text-center">
            ISO 14001 – Sistema de Gestão Ambiental
          </h3>
          <p>
            É aplicável somente em empresas de grande porte. É uma norma aceita
            internacionalmente que define os requisitos para colocar um sistema
            de gestão ambiental em vigor, ajuda a melhorar o desempenho das
            empresas por meio da utilização eficiente dos recursos e da redução
            da quantidade de resíduos, ganhando assim a confiança das partes
            interessadas.
          </p>
          <button
            className="button-pdf text-center"
            onClick={() => abrirPDF(dociso14001)}
          >
            Clique aqui para visualizar o certificado.
          </button>
        </div>

        <div>
          <img src={iso45001} alt="iso 45001"></img>
          <h3 className="fw-bold mb-3 text-center">
            ISO 45001 – Sistema de Gestão de Segurança e Saúde Ocupacional
          </h3>
          <p>
            É uma norma internacional para o Sistema de Gestão de Saúde e
            Segurança Ocupacional (SGSSO), a qual traz como foco a melhoria do
            desempenho da empresa em termos de Saúde e Segurança do Trabalho
            (SST). A OM é certificado da QMS Certification na norma ISO 9001,
            ISO 14001 e ISO 45001.
          </p>
          <button
            className="button-pdf text-center"
            onClick={() => abrirPDF(dociso45001)}
          >
            Clique aqui para visualizar o certificado.
          </button>
        </div>
      </section>
      <section>
        <h3 className="mt-4 mb-3">
          <b>
            Essas certificações demonstram o nosso compromisso contínuo com:
          </b>
        </h3>
        <p>✔️ A excelência nos processos e na satisfação do cliente</p>
        <p>✔️ A sustentabilidade e responsabilidade ambiental</p>
        <p>✔️ A segurança e o bem-estar dos nossos colaboradores</p>
      </section>
    </article>
  );
}
